import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { ConversationsResponse } from "../schemas/messaging";

export const queryKeyPrefix = "getConversations";
type QueryKey = [typeof queryKeyPrefix, number];
const getConversationsQueryKey = (userID: number): QueryKey => [queryKeyPrefix, userID];

export const useGetConversations = (
  userID: number,
  options?: UseQueryOptions<ConversationsResponse, Error, ConversationsResponse, QueryKey>
) => {
  const client = useApiClient();

  return useQuery({
    queryKey: getConversationsQueryKey(userID),
    queryFn: () => client.getConversations(userID),
    ...options,
  });
};
